import { useAppDispatch, useAppSelector } from '@/store/hooks/redux';
import { selectIsSliderActive } from '@/editor/store/selectors/selected-platforms.selectors';
import { AvailablePlatformsEnum } from '@/editor/shared/constants/available-platforms';
import { useEffect } from 'react';
import { mapService } from '@/editor/components/googleMaps/google-map-service';
import { selectPlaces, updatePlaceRadius } from '@/editor/store/reducers/adSet-step.slice';
import { ICircleViewModel } from '@/editor/shared/components/forms/ad-settings/ConfiguredGoogleMap';
import { CircleRadius } from '@/editor/components/googleMaps/GoogleAutocomplete';

export const useDetectPlatformActive = () => {
  const isMetaActive = useAppSelector((state) => selectIsSliderActive(state, AvailablePlatformsEnum.META));
  const places = useAppSelector(selectPlaces);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isMetaActive === null || isMetaActive === undefined) return;

    let minimalRadius = isMetaActive ? CircleRadius.META : CircleRadius.DEFAULT;
    if (places.length > 0) {
      places.forEach((el: ICircleViewModel) => {
        dispatch(updatePlaceRadius({ address: el.address, radius: minimalRadius }));
      });

      mapService.changeDefaultRadius(isMetaActive, minimalRadius);
    }
  }, [isMetaActive]);
};
